class ScrollTop {
  constructor() {
    this.button = document.querySelector(".js-scroll-top");
    if (!this.button) return;

    this.threshold = 280;
    this.footer = document.querySelector('footer');
    this.onScroll = this.onScroll.bind(this);
    this.bind();
    this.observeFooter();
  }

  bind() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.button.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    this.onScroll();
  }

  observeFooter() {
    if (!this.footer) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.button.classList.add('footer-active');
        } else {
          this.button.classList.remove('footer-active');
        }
      });
    }, {
      rootMargin: '-100px 0px 0px 0px'
    });

    observer.observe(this.footer);
  }

  onScroll() {
    const shouldShow = window.scrollY > this.threshold;
    this.button.classList.toggle("is-visible", shouldShow);
  }
}

export default ScrollTop;
